import { __read } from "tslib";
import { KEEN_KEY } from '@keen.io/parser';
export var setChartSettings = function (_a) {
    var keys = _a.keys;
    var _b = __read(keys, 1), valueKey = _b[0];
    return {
        geoKey: KEEN_KEY,
        valueKey: valueKey,
    };
};
